import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'

const API_URL = process.env.REACT_APP_API_URL

class DeliveryAssociateService {
    // Get all delivery associates with pagination and search
    static async getDeliveryAssociates(params = {}) {
        try {
            const queryParams = new URLSearchParams({
                search: params.search || '',
                sortBy: params.sortBy || 'created_at',
                sortOrder: params.sortOrder || 'desc',
                perPage: params.perPage || 10,
                page: params.page || 1,
                ...params
            }).toString()

            const response = await fetch(`${API_URL}delivery-associates?${queryParams}`, getRequestOptions())
            return await response.json()
        } catch (error) {
            console.error('Error fetching delivery associates:', error)
            throw error
        }
    }

    // Get delivery associate by ID
    static async getDeliveryAssociate(id) {
        try {
            const response = await fetch(`${API_URL}delivery-associates/${id}`, getRequestOptions())
            return await response.json()
        } catch (error) {
            console.error('Error fetching delivery associate:', error)
            throw error
        }
    }

    // Create new delivery associate
    static async createDeliveryAssociate(data) {
        try {
            const response = await fetch(`${API_URL}delivery-associates`, postRequestOptions(data))
            return await response.json()
        } catch (error) {
            console.error('Error creating delivery associate:', error)
            throw error
        }
    }

    // Update delivery associate
    static async updateDeliveryAssociate(id, data) {
        try {
            const response = await fetch(`${API_URL}delivery-associates/${id}`, {
                ...postRequestOptions(data),
                method: 'PUT'
            })
            return await response.json()
        } catch (error) {
            console.error('Error updating delivery associate:', error)
            throw error
        }
    }

    // Delete delivery associate
    static async deleteDeliveryAssociate(id) {
        try {
            const response = await fetch(`${API_URL}delivery-associates/${id}`, {
                ...getRequestOptions(),
                method: 'DELETE'
            })
            return await response.json()
        } catch (error) {
            console.error('Error deleting delivery associate:', error)
            throw error
        }
    }

    // Get delivery associates dropdown options
    static async getDeliveryAssociatesDropdown() {
        try {
            const response = await fetch(`${API_URL}delivery-associates-dropdown`, getRequestOptions())
            return await response.json()
        } catch (error) {
            console.error('Error fetching delivery associates dropdown:', error)
            throw error
        }
    }

    // Assign delivery associate to shipment
    static async assignToShipment(shipmentId, deliveryAssociateId) {
        try {
            const data = {
                shipment_id: shipmentId,
                delivery_associate_id: deliveryAssociateId
            }
            const response = await fetch(`${API_URL}delivery-associates/assign-shipment`, postRequestOptions(data))
            return await response.json()
        } catch (error) {
            console.error('Error assigning delivery associate to shipment:', error)
            throw error
        }
    }

    // Remove delivery associate from shipment
    static async removeFromShipment(shipmentId) {
        try {
            const data = {
                shipment_id: shipmentId
            }
            const response = await fetch(`${API_URL}delivery-associates/remove-shipment`, postRequestOptions(data))
            return await response.json()
        } catch (error) {
            console.error('Error removing delivery associate from shipment:', error)
            throw error
        }
    }

    // Format phone number for display
    static formatPhoneNumber(phone) {
        if (!phone) return 'N/A'
        return phone
    }

    // Format date for display
    static formatDate(dateString) {
        if (!dateString) return 'N/A'
        try {
            const date = new Date(dateString)
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        } catch (error) {
            return dateString
        }
    }

    // Format date for display (short format)
    static formatDateShort(dateString) {
        if (!dateString) return 'N/A'
        try {
            const date = new Date(dateString)
            return date.toLocaleDateString()
        } catch (error) {
            return dateString
        }
    }

    // Validate delivery associate data
    static validateDeliveryAssociate(data) {
        const errors = []

        if (!data.name || !data.name.trim()) {
            errors.push('Name is required')
        } else if (data.name.trim().length < 2) {
            errors.push('Name must be at least 2 characters long')
        }

        if (!data.phone || !data.phone.trim()) {
            errors.push('Phone number is required')
        } else if (!/^\+?[\d\s\-\(\)]{10,}$/.test(data.phone.trim())) {
            errors.push('Please enter a valid phone number')
        }

        return errors
    }
}

export default DeliveryAssociateService 